import React from 'react';
import PropTypes from 'prop-types';
import ActivityButton from './ActivityButton';
import PatientRecord from '../../../../common/models/PatientRecord';
import { ACTIVITY_STATE__COMPLETED } from '../../../../common/constants';
import NotificationLog from '../../../../common/models/NotificationLog';
import TimelineEventDomain from './TimelineEventDomain';

const Activity = ({
  activity,
  patientRecord,
  onMilestoneClick,
  isDischarged,
  showBadge,
  clinicalEvents,
}) => {
  if (!activity) {
    return <div />;
  }

  const { state, activityId, notification, eventId, reviewHistory } = activity;
  const milestoneId = activity && activity.milestoneId;
  const { projectId, recipientId } = patientRecord;

  return (
    <ActivityButton
      patientRecord={patientRecord}
      state={state}
      activityId={activityId}
      milestoneId={milestoneId}
      recipientId={recipientId}
      notification={notification ? new NotificationLog(notification) : null}
      onMilestoneClick={onMilestoneClick}
      isDischarged={isDischarged}
      reviewHistory={reviewHistory}
      showBadge={showBadge}
      eventId={eventId}
      clinicalEvents={clinicalEvents}
    />
  );
};

Activity.propTypes = {
  patientRecord: PropTypes.instanceOf(PatientRecord).isRequired,
  activity: PropTypes.shape({
    state: PropTypes.string,
    activityId: PropTypes.string,
    milestoneId: PropTypes.string,
  }),
  onMilestoneClick: PropTypes.func,
  isDischarged: PropTypes.bool,
  showBadge: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  clinicalEvents: PropTypes.object,
};

Activity.defaultProps = {
  activity: null,
  onMilestoneClick: null,
  isDischarged: false,
  showBadge: false,
  clinicalEvents: {},
};

export default Activity;
